import React from 'react'

import { Box, Typography } from '@mui/material'

export const ContentHeader = ({ title, icon }) => {
  return (
    <Box sx={{ backgroundColor: '#162131', display: 'flex', justifyContent: 'center', alignItems: 'center', height: { xs: '60px', lg: '100px' }, borderTopRightRadius: { lg: 10 }, position: 'sticky' , top: 0, top: '0px', zIndex:2000}}>
      {icon({ color: 'primary' })}
      <Typography color='white.main' sx={{ mx: 2 }} fontSize={20}>{title}</Typography>
    </Box>
  )
}
